/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník formátů pro aktualizaci aplikace.
 * @enum {string}
 * @name FormatEnum
 */
export default {
  HTML: 'HTML',
  IPK: 'IPK',
  WGT: 'WGT',
  ZIP: 'ZIP'
};
